import React, { FC, useMemo } from 'react'
import { palette } from 'theme/palette'
import { StarRating, StarRatingFill } from 'icons/Icons'
import { RatingItemType } from 'models/MessageType'

import { StarsRatingButton, StarsRatingItem } from './Rating.styles'

interface Props {
  item: RatingItemType
  isDisabled: boolean
  rating: number
  onClickHandler: (item: RatingItemType) => void
}

const StarsRating: FC<Props> = ({
  item,
  isDisabled,
  rating,
  onClickHandler
}) => {
  const starColor = useMemo(() => isDisabled ? palette.mediumGray : palette.mainBlue, [isDisabled])
  const StarView = (value: number) => (value <= rating) ? <StarRatingFill color={starColor} /> : <StarRating color={starColor} />

  return (
    <StarsRatingItem key={item.scoreNumber}>
      <StarsRatingButton
        role='checkbox'
        aria-label={item.ariaLabel}
        aria-checked={item.scoreNumber <= rating}
        onClick={() => onClickHandler(item)}
        isDisabled={isDisabled}
        disabled={isDisabled}
      >
        { StarView(item.scoreNumber) }
      </StarsRatingButton>
    </StarsRatingItem>
  )
}

export default StarsRating
